import { YearStatisticDTO } from "./dto/WorksStatisticDTO";

export interface WorksStatisticState {
    worksStatisticYear: YearStatisticDTO[];
}

export const InitialWorksStatistic: WorksStatisticState = {
    worksStatisticYear: [],
};
